import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import VipTablesRequests from "./VipTablesRequests";
import "./VipTables.css";
import FormTables from "./Tables/FormTables";
import FormFloorImage from "./Tables/FormFloorImage";
import VipTablesTabs from "./VipTablesTabs";
import TermsConditionsVipTables from "./TermsConditions/TermsConditionsVipTables";
import { Puff } from "react-loading-icons";
import NavBar from "../../../../../components/NavBar";

const VipTablesConfig = () => {
  let params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [state, setState] = useState({
    modalFormTables: {
      show: false,
      id: 0,
    },
    modalFormFloorImage: {
      show: false,
      id: 0,
    },
    tableList: [],
    terms_condition_readed: false,
  });

  const getTablesList = async () => {
    setIsLoading(true);
    let info = await VipTablesRequests.getTables({ id_venues: params.id });
    if (info && info.status) {
      setState((prevState) => ({
        ...prevState,
        tableList: info.data.tables,
        terms_condition_readed: info.data.terms_condition_readed,
      }));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTablesList();
  }, []);

  useEffect(() => {
    if (state.modalFormTables.show === false) getTablesList();
  }, [state.modalFormTables.show]);

  const handlerShowFormTable = () => {
    setState({
      ...state,
      modalFormTables: {
        ...state.modalFormTables,
        show: true,
        id: 0,
      },
    });
  };

  const handlerShowFormFloorImage = () => {
    setState({
      ...state,
      modalFormFloorImage: {
        ...state.modalFormFloorImage,
        show: true,
      },
    });
  };

  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A carregar mesas...</div>
    </div>
  );

  const ListTables = () => {
    return state.tableList.map((item) => (
      <div
        key={item.id}
        className="col-12 col-md-4 mb-4"
        onClick={() =>
          setState({
            ...state,
            modalFormTables: {
              ...state.modalFormTables,
              show: true,
              id: item.id,
            },
          })
        }
      >
        <div className="campaign-card glass-glow h-100 p-4 border-0" style={{ borderLeft: `6px solid ${item.color} !important`, cursor: 'pointer' }}>
          <div className="d-flex justify-content-between align-items-start mb-3">
            <h3 className="fs-4 fw-bold text-white mb-0">{item.name}</h3>
            <div className="bg-white bg-opacity-10 px-3 py-1 rounded-pill small fw-bold text-white">
              {item.base_price}€
            </div>
          </div>

          <div className="d-flex align-items-center text-muted small mb-3">
            <i className="fa-solid fa-users me-2"></i>
            Até {item.numberOfGuests} pessoas
          </div>

          <p className="text-muted small mb-0 line-clamp-2" style={{ opacity: 0.8 }}>
            {item.description || "Sem descrição definida."}
          </p>

          <div className="mt-4 pt-3 border-top border-white border-opacity-10 d-flex justify-content-end">
            <span className="text-primary small fw-bold">Editar Detalhes <i className="fa-solid fa-chevron-right ms-1"></i></span>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <NavBar>
      <div className="py-4 dashboard-content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb premium-breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/my/dashboard">
                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/my/nightspots">Nightspots</Link>
            </li>
            <li className="breadcrumb-item active">Gestão de Mesas</li>
          </ol>
        </nav>



        {isLoading ? (
          <InsideLoading />
        ) : (
          <div className="mt-4">
            <div className="row g-4 align-items-center mb-5">
              <div className="col-12 col-md-6">
                <h2 className="campaigns-section-title fs-2 mb-1">Configuração de Mesas</h2>
                <p className="campaigns-section-subtitle mb-0">Desenha o teu espaço e define os preços base para as tuas mesas VIP.</p>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end gap-3">
                <button
                  className="btn-action btn-campaign-secondary px-4 rounded-pill w-auto py-2"
                  onClick={() => handlerShowFormFloorImage()}
                >
                  <i className="fa-solid fa-image me-2"></i>Planta da Sala
                </button>
                <button
                  className="btn-action btn-campaign-primary px-4 rounded-pill w-auto py-2"
                  onClick={() => handlerShowFormTable()}
                >
                  <i className="fa-solid fa-plus me-2"></i>Adicionar Mesa
                </button>
              </div>
            </div>

            <div className="row">
              <ListTables />
              {state.tableList.length === 0 && (
                <div className="col-12">
                  <div className="instruction-box text-center p-5 rounded-4">
                    <i className="fa-solid fa-couch fs-1 text-muted mb-3"></i>
                    <h4 className="text-white">Nenhuma mesa configurada</h4>
                    <p className="text-muted">Começa por adicionar a tua primeira mesa VIP.</p>
                  </div>
                </div>
              )}
            </div>

            <TermsConditionsVipTables
              show={!state.terms_condition_readed}
              handleModalhide={() => getTablesList()}
            />
          </div>
        )}
      </div>

      <FormTables
        show={state.modalFormTables.show}
        handleModalShow={() =>
          setState({
            ...state,
            modalFormTables: {
              ...state.modalFormTables,
              show: true,
            },
          })
        }
        handleModalhide={() =>
          setState({
            ...state,
            modalFormTables: {
              ...state.modalFormTables,
              show: false,
            },
          })
        }
        id={state.modalFormTables.id}
      />
      <FormFloorImage
        show={state.modalFormFloorImage.show}
        handleModalShow={() =>
          setState({
            ...state,
            modalFormFloorImage: {
              ...state.modalFormFloorImage,
              show: true,
            },
          })
        }
        handleModalhide={() =>
          setState({
            ...state,
            modalFormFloorImage: {
              ...state.modalFormFloorImage,
              show: false,
            },
          })
        }
        id={state.modalFormFloorImage.id}
      />
    </NavBar>
  );
};

export default VipTablesConfig;
